module.exports = __webpack_public_path__ + "public/Icons/11Managedeliverytype.svg?05d7a764";